import { render, staticRenderFns } from "./country.vue?vue&type=template&id=4b1db294"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b1db294')) {
      api.createRecord('4b1db294', component.options)
    } else {
      api.reload('4b1db294', component.options)
    }
    module.hot.accept("./country.vue?vue&type=template&id=4b1db294", function () {
      api.rerender('4b1db294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/country.vue"
export default component.exports